'use client';

import { useIntl } from 'react-intl';
import {
  PriceDiscount,
  type PriceDiscountProps,
} from '@packages/shared/src/ui/Price/PriceDiscount/PriceDiscount';
import { priceDiscountMessages } from './messages';

type PriceDiscountLocalizedProps = Omit<PriceDiscountProps, 'aria-label'>;

export const PriceDiscountLocalized = (props: PriceDiscountLocalizedProps) => {
  const { formatMessage } = useIntl();

  return (
    <PriceDiscount
      {...props}
      oldPriceAriaLabel={formatMessage(priceDiscountMessages.originalPrice)}
      discountAriaLabel={formatMessage(priceDiscountMessages.discount)}
    />
  );
};
